import { canv } from "@/canv/global";
import { getNewStartYByHeight } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeTriangle extends Shape {
    width = 200;
    height = 172;

    fitText(textPart: ShapeTextPart, x: number, y: number, width: number, height: number) {
        const k = (height * width) / (height + width);
        const allowedWidth = k;
        const allowedHeight = k;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartYByHeight(
            textPart,
            y,
            height,
            height * 2,
            height - allowedHeight / 2,
            0,
        );

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    clipAriaCoordinateY(y: number, h: number, allowedHeight: number) {
        return y + h - allowedHeight / 2;
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width / 2, y);
        canv.ctx.lineTo(x, y + height);
        canv.ctx.lineTo(x + width, y + height);
        canv.ctx.lineTo(x + width / 2, y);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M1.54071 18.25L11.5 1L21.4593 18.25H1.54071Z"/>
            </svg>
        `;
    }
}
